export enum SharedItemActionType {
    Reply,
    New,
    View
}
